/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DocumentUploadTranslations } from './DocumentUploadTranslations';
import type { GenericFinalScreenTranslations } from './GenericFinalScreenTranslations';
import type { FinalScreenTranslations } from './FinalScreenTranslations';
import type { AutosaveTranslations } from './AutosaveTranslations';
import type { CommonActionTranslations } from './CommonActionTranslations';
import type { DeclinedScreenTranslations } from './DeclinedScreenTranslations';
import type { VerificationTranslations } from './VerificationTranslations';
import type { AddressTranslations } from './AddressTranslations';
import type { CaptchaSecurityCheckTranslations } from './CaptchaSecurityCheckTranslations';
import type { DocumentResubmissionTranslations } from './DocumentResubmissionTranslations';
import type { TaxIdentificationNumberTranslations } from './TaxIdentificationNumberTranslations';
import type { CommonLabelsTranslation } from './CommonLabelsTranslation';
import type { SubmittedScreen } from './SubmittedScreen';
import type { VehicleTypeTranslations } from './VehicleTypeTranslations';
import type { AppPromotion } from './AppPromotion';
import type { VehicleMarketplaceTranslations } from './VehicleMarketplaceTranslations';

export interface CommonTranslations {
    document_upload: DocumentUploadTranslations;
    document_resubmission: DocumentResubmissionTranslations;
    common_actions: CommonActionTranslations;
    common_labels: CommonLabelsTranslation;
    app_promotion: AppPromotion;
    verification: VerificationTranslations;
    tax_identification_numbers: TaxIdentificationNumberTranslations;
    final_screen: FinalScreenTranslations;
    generic_final_screen: GenericFinalScreenTranslations;
    declined_screen: DeclinedScreenTranslations;
    common_unknown_error: string;
    captcha_security_check: CaptchaSecurityCheckTranslations;
    autosave: AutosaveTranslations;
    vehicle_marketplace_screen: VehicleMarketplaceTranslations;
    vehicle_types: VehicleTypeTranslations;
    address: AddressTranslations;
    submitted_screen: SubmittedScreen;
}
